module.exports = "void main() {\n\t  gl_FragColor = vec4(1.);\n}"